const getters = {
  sidebar: state => state.app.sidebar,
  user: state => state.user.userInfo,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRoutes,
  permission_routes: state => state.permission.routes,
}
export default getters
